var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -6.11 87.5 87.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.63 0c-1.96.007-3.935.948-5.338 2.82C36.093 5.754 2.004 62.916.3 66.528c-1.279 4.316 1.785 8.722 4.536 8.545.676.165 9.362.206 39.269.183 37.426-.029 36.21.063 37.536-.016 4.07.057 6.959-4.86 5.456-8.432-.206-.46-4.627-7.822-9.825-16.358a2504.215 2504.215 0 0 1-18.623-31.187c-5.043-8.617-9.43-16.035-9.755-16.48C47.538.92 45.59-.008 43.63 0zm-4.778 21.588h9.755c-.528 7.879-.837 17.32-1.318 26.516h-7.033c-.678-8.24-.86-17.09-1.404-26.516zm4.87 31.537a5.639 5.639 0 1 1 0 11.277 5.639 5.639 0 0 1 0-11.277z",
    fill: "#EED202"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertYellow);
export default __webpack_public_path__ + "static/media/alert-yellow.2cb667aa.svg";
export { ForwardRef as ReactComponent };